import { useState } from 'react';
import { useTheme } from '../../context/ThemeContext.jsx';
import { AVATAR_COLORS } from './shared.js';

export default function EditUserModal({ user, onClose, onSave }) {
  const { theme } = useTheme();
  const [name, setName] = useState(user.name);
  const [initials, setInitials] = useState(user.initials || '');
  const [color, setColor] = useState(user.color || AVATAR_COLORS[0]);

  const handleSave = async () => {
    await onSave(user.id, { name, initials, color });
    onClose();
  };

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 300,
        background: theme.overlay,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
      onClick={onClose}
    >
      <div onClick={e => e.stopPropagation()} style={{
        width: 400, padding: 28,
        background: theme.bg, border: `2px solid ${theme.text}`,
      }}>
        <h3 style={{ fontFamily: "'Aeonik', Arial, Helvetica, sans-serif", fontWeight: 450, margin: '0 0 20px', fontSize: 20, color: theme.text }}>edit user</h3>

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 10, letterSpacing: '0.12em', textTransform: 'uppercase', color: theme.textFaint, marginBottom: 6 }}>name</label>
          <input type="text" value={name} onChange={e => setName(e.target.value)} autoFocus
            style={{ width: '100%', height: 40, padding: '0 12px', background: 'transparent', border: `1px solid ${theme.borderMedium}`, borderRadius: 0, color: theme.text, fontSize: 13, outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box' }} />
        </div>

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 10, letterSpacing: '0.12em', textTransform: 'uppercase', color: theme.textFaint, marginBottom: 6 }}>initials</label>
          <input type="text" value={initials} onChange={e => setInitials(e.target.value.toUpperCase().slice(0, 4))} maxLength={4}
            style={{ width: 80, height: 40, padding: '0 12px', background: 'transparent', border: `1px solid ${theme.borderMedium}`, borderRadius: 0, color: theme.text, fontSize: 13, outline: 'none', fontFamily: 'inherit', textAlign: 'center', letterSpacing: '0.1em', boxSizing: 'border-box' }} />
        </div>

        <div style={{ marginBottom: 24 }}>
          <label style={{ display: 'block', fontSize: 10, letterSpacing: '0.12em', textTransform: 'uppercase', color: theme.textFaint, marginBottom: 6 }}>avatar color</label>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            {AVATAR_COLORS.map(c => (
              <button key={c} onClick={() => setColor(c)} style={{
                width: 24, height: 24,
                background: c, border: `1px solid ${color === c ? theme.text : theme.border}`,
                outline: color === c ? `1px solid ${theme.bg}` : 'none',
                outlineOffset: color === c ? -3 : 0,
                cursor: 'pointer', padding: 0, borderRadius: 0,
              }} />
            ))}
          </div>
          <div style={{ marginTop: 12, display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{
              width: 36, height: 36, border: `1px solid ${theme.borderMedium}`,
              background: color, display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 12, letterSpacing: '0.06em', color: theme.bg,
            }}>{initials || '??'}</div>
            <span style={{ fontSize: 12, color: theme.textFaint, textTransform: 'lowercase' }}>preview</span>
          </div>
        </div>

        <div style={{ display: 'flex' }}>
          <button onClick={onClose} style={{ flex: 1, height: 42, background: 'transparent', border: `1px solid ${theme.borderMedium}`, color: theme.text, fontSize: 13, textTransform: 'lowercase', cursor: 'pointer', fontFamily: 'inherit' }}>cancel</button>
          <button onClick={handleSave} style={{ flex: 1, height: 42, background: theme.fill, border: 'none', color: theme.fillFg, fontSize: 13, textTransform: 'lowercase', cursor: 'pointer', fontFamily: 'inherit' }}>save changes</button>
        </div>
      </div>
    </div>
  );
}
